import {
  DASHBOARD_LOOK_UP,
  EID_FORM_LIST,
  FACILITY_LOOK_UP,
  FETCH_APPROVE_TEST_CONFIGURATION,
  FETCH_END,
  FETCH_ENTER_TEST_CONFIGURATION,
  FETCH_ERROR,
  FETCH_GENERAL_TEST_CONFIGURATION,
  FETCH_GO_TEST_CONFIGURATION,
  FETCH_INSTRUMENT,
  FETCH_LAB_SECTION,
  FETCH_LOCAL_GOVERNMENT_AREA_LIST,
  FETCH_METHOD,
  FETCH_OCCUPATION_LIST,
  FETCH_PROGRAM_LIST,
  FETCH_REJECTION_REASON,
  FETCH_RESULT_REJECTION_REASON,
  FETCH_START,
  FETCH_STATE_LIST,
  FETCH_SUCCESS,
  FETCH_TB_TEST_CONFIGURATION,
  FETCH_TEST_CONFIGURATION,
  FETCH_TEST_STATUS_CONFIGURATION,
  FETCH_TEST_TYPE,
  FETCH_WORKSHEET_LIST,
  GENERAL_ORDER_LOOK_UP,
  HIDE_MESSAGE,
  PH_TEST_SAMPLES_LOOK_UP,
  SAMPLE_COLLECTION_LOOKUP_LIST,
  SERVICE_TEST_TAT_LIST,
  SET_BENCH,
  SET_FILTER_TYPE,
  SET_PROGRAM,
  PH_PROTOCOLS,
  PH_STAGES,
  SET_ROLES,
  SET_SAMPLE_TYPE,
  SHOW_MESSAGE,
  TB_FORM_LIST,
  TEST_CONFIG_LOOK_UP,
  TOGGLE_COLLAPSED_NAV,
  UPDATE_LGA,
  UPDATE_PROGRAM,
  UPDATE_STATE,
  USER_LOCATION_LOOK_UP,
  VL_FORM_LIST,
  WINDOW_WIDTH
} from "constants/ActionTypes";

const INIT_STATE = {
  error: "",
  currentProgram: "",
  loading: false,
  message: "",
  navCollapsed: true,
  localGovernmentAreaList: [],
  programList: [],
  stateList: [],
  tbFormList: [],
  eidFormList: [],
  vlFormList: [],
  protocols:[],
  stages:[],
  facilityFormList: [],
  generalOrderFormList: [],
  roleList: [],
  testTypeList: [],
  benchList: [],
  sectionList: [],
  methodList: [],
  testEnterConfigList: [],
  testConfigList: [],
  testTBConfigList: [],
  testGOConfigList: [],
  collectedSampleList: [],
  phTestSampleList: [],
  testConfigLookUpList: [],
  userLocationLookUpList: [],
  instrumentList: [],
  sampleRejectionList: [],
  resultRejectionList: [],
  testGeneralConfigList: [],
  occupationList: [],
  serviceTATList: [],
  testCountList: [],
  dashboardLookupList: [],
  hospitalNumber: 1,
  labNumber: 2,
  lgaTBNumber: 4,
  drRegisterNumber: 5,
  nationalSecurityNumber: 6,
  currentState: null,
  currentLga: null,
  attributeType: 1,
  tierList: ["Primary", "Secondary", "Reference", "Research", "Tertiary"],
  tbTestList: ["Smear", "Xpert/MTB/RIF", "LPA", "Culture", "DST"],
  testStatusList: ["Initial", "Follow-Up", "Repeat"],
  labNetwork: [],
  worksheetList: [],

  superAdminRoles: ["SuperAdmin", "Admin"],
  dataEntryRoles: ["Data Clerk", "Admin", "Analyst"],
  filterType: {
    selectedIdentifier: "",
    searchText: "",
  },

  program: {},
  width: window.innerWidth,
  pathname: "/",
};

const CommonReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      return {
        ...state,
        pathname: action.payload.location.pathname,
        navCollapsed: false,
      };
    }
    // #fa8c15
    case SET_FILTER_TYPE: {
      return {
        ...state,
        filterType: action.payload,
      };
    }
    case UPDATE_PROGRAM: {
      return {
        ...state,
        currentProgram: action.payload,
      };
    }
    case UPDATE_STATE: {
      return {
        ...state,
        currentState: action.payload,
      };
    }
    case UPDATE_LGA: {
      return {
        ...state,
        currentLga: action.payload,
      };
    }
    case DASHBOARD_LOOK_UP: {
      return {
        ...state,
        dashboardLookupList: action.payload,
      };
    }
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case TOGGLE_COLLAPSED_NAV: {
      return {
        ...state,
        navCollapsed: action.navCollapsed,
      };
    }
    case FETCH_START: {
      return { ...state, error: "", message: "", loading: true };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: "", loading: false, message: action.payload };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, message: "", error: action.payload };
    }

    case FETCH_END: {
      return { ...state, loading: false };
    }

    case SHOW_MESSAGE: {
      return { ...state, error: "", message: action.payload, loading: false };
    }

    case HIDE_MESSAGE: {
      return { ...state, loading: false, error: "", message: "" };
    }
    case FETCH_STATE_LIST: {
      return {
        ...state,
        stateList: action.payload,
      };
    }
    case TB_FORM_LIST: {
      return {
        ...state,
        tbFormList: action.payload,
      };
    }
    case FETCH_TEST_TYPE: {
      return {
        ...state,
        testTypeList: action.payload,
      };
    }
    case FETCH_LAB_SECTION: {
      return {
        ...state,
        sectionList: action.payload,
      };
    }
    case FETCH_REJECTION_REASON: {
      return {
        ...state,
        sampleRejectionList: action.payload,
      };
    }
    case FETCH_RESULT_REJECTION_REASON: {
      return {
        ...state,
        resultRejectionList: action.payload,
      };
    }
    case FETCH_TEST_CONFIGURATION: {
      return {
        ...state,
        testConfigList: action.payload,
      };
    }
    case FETCH_GENERAL_TEST_CONFIGURATION: {
      return {
        ...state,
        testGeneralConfigList: action.payload,
      };
    }
    case SERVICE_TEST_TAT_LIST: {
      return {
        ...state,
        serviceTATList: action.payload,
      };
    }
    case FETCH_APPROVE_TEST_CONFIGURATION: {
      return {
        ...state,
        testApprovedConfigList: action.payload,
      };
    }
    case FETCH_ENTER_TEST_CONFIGURATION: {
      return {
        ...state,
        testEnterConfigList: action.payload,
      };
    }
    case USER_LOCATION_LOOK_UP: {
      return {
        ...state,
        userLocationLookUpList: action.payload,
      };
    }
    case PH_PROTOCOLS: {
      return {
        ...state,
        protocols: action.payload,
      };
    }
    case PH_STAGES: {
      return {
        ...state,
        stages: action.payload,
      };
    }
    case FETCH_GO_TEST_CONFIGURATION: {
      return {
        ...state,
        testGOConfigList: action.payload,
      };
    }

    case TEST_CONFIG_LOOK_UP: {
      return {
        ...state,
        testConfigLookUpList: action.payload,
      };
    }
    case SAMPLE_COLLECTION_LOOKUP_LIST: {
      return {
        ...state,
        specimenCollectionLookupList: action.payload,
      };
    }
    case EID_FORM_LIST: {
      return {
        ...state,
        eidFormList: action.payload,
      };
    }
    case VL_FORM_LIST: {
      return {
        ...state,
        vlFormList: action.payload,
      };
    }
    case FACILITY_LOOK_UP: {
      return {
        ...state,
        facilityFormList: action.payload,
      };
    }
    case GENERAL_ORDER_LOOK_UP: {
      return {
        ...state,
        generalOrderFormList: action.payload,
      };
    }
    case FETCH_PROGRAM_LIST: {
      return {
        ...state,
        programList: action.payload,
      };
    }
    case FETCH_METHOD: {
      return {
        ...state,
        methodList: action.payload,
      };
    }
    case FETCH_INSTRUMENT: {
      return {
        ...state,
        instrumentList: action.payload,
      };
    }
    case PH_TEST_SAMPLES_LOOK_UP: {
      return {
        ...state,
        phTestSampleList: action.payload,
      };
    }
    case FETCH_OCCUPATION_LIST: {
      return {
        ...state,
        occupationList: action.payload,
      };
    }
    case FETCH_LOCAL_GOVERNMENT_AREA_LIST: {
      return {
        ...state,
        localGovernmentAreaList: action.payload,
      };
    }
    case FETCH_TEST_STATUS_CONFIGURATION: {
      return {
        ...state,
        testCountList: action.payload,
      };
    }
    case SET_ROLES: {
      return {
        ...state,
        roleList: action.payload,
      };
    }
    case SET_BENCH: {
      return {
        ...state,
        benchList: action.payload,
      };
    }
    case SET_PROGRAM: {
      return {
        ...state,
        program: action.payload,
      };
    }

    case SET_SAMPLE_TYPE: {
      return {
        ...state,
        sampleTypeList: action.payload,
      };
    }
    case FETCH_TB_TEST_CONFIGURATION: {
      return {
        ...state,
        testTBConfigList: action.payload,
      };
    }
    case FETCH_WORKSHEET_LIST: {
      return {
        ...state,
        worksheetList: action.payload,
      };
    }
    default:
      return state;
  }
};

export default CommonReducer;
